import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { provideZoneChangeDetection } from '@angular/core';

import { AppModule } from './app/app.module';


// Angular 21 no longer schedules zone-based change detection implicitly for
// NgModule bootstrap. This application depends on zone.js-driven change detection:
// state updated outside the Angular zone (for example the MSAL authentication
// callbacks that drive the root loader and authorization gates) would otherwise
// never trigger a change-detection tick, leaving the DOM stale.
// provideZoneChangeDetection() restores explicit zone-based scheduling until the
// application is migrated to signals / zoneless change detection.
platformBrowserDynamic().bootstrapModule(AppModule, {
  applicationProviders: [provideZoneChangeDetection()]
})
  .catch(err => console.error(err));
